import React from 'react';
import cn from 'classnames';

import Link from '../../components/common/ui/Link';
import { HOME, LOGIN } from '../../routes';
import LayoutWithBg from '../../components/layout/LayoutWithBg';
import NotFoundIcon from '../../assets/icons/404/NotFoundIcon';
import { getSession } from '../../utils/session';

import styles from './styles.module.scss';

const Page404 = () => {
  const isLogged = getSession();

  return (
    <LayoutWithBg className={styles.notFoundPage}>
      <div className={styles.notFound}>
        <NotFoundIcon className={styles.notFoundIcon}></NotFoundIcon>
        <h1 className={styles.notFoundText}>
          Oops... This page doesn't seem to exist.
        </h1>
        {isLogged ? (
          <Link to={HOME} className={styles.notFoundButton}>
            Go to HomeFi Dashboard
          </Link>
        ) : (
          <Link
            to={LOGIN}
            className={cn(styles.notFoundButton, styles.loginButton)}
          >
            Login to HomeFi Dashboard
          </Link>
        )}
      </div>
    </LayoutWithBg>
  );
};

export default Page404;
